import React from "react";
import { useTranslation } from "react-i18next";
//MUI components
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

function Customer({
  showCustomerData,
  setShowCustomerData,
  handleChange,
  ERPId,
  customerName,
  customerRepresentative,
  customerPhone,
  customerEmail,
}) {
  const { t } = useTranslation();
  return (
    <Paper
      variant="outlined"
      sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
    >
      <Box>
        <header>
          <Typography component="h2" variant="h5">
            {t("customer.sectionTitle")}
          </Typography>
          <button
            className="btn"
            onClick={() => setShowCustomerData(!showCustomerData)}
          >
            {!showCustomerData ? <AiOutlineMinus /> : <AiOutlinePlus />}
          </button>
        </header>
        {!showCustomerData && (
          <>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ width: "15%", margin: 1 }}>
                <TextField
                  fullWidth
                  id="ERPId"
                  label={t("customer.ERPId")}
                  name="ERPId"
                  value={ERPId}
                  type="string"
                  inputType="string"
                  onChange={handleChange}
                />
              </Box>
              <Box sx={{ width: "50%", margin: 1 }}>
                <TextField
                  fullWidth
                  id="customerName"
                  label={t("customer.customerName")}
                  name="customerName"
                  value={customerName}
                  type="string"
                  inputType="string"
                  onChange={handleChange}
                />
              </Box>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box sx={{ width: "50%", margin: 1 }}>
                <TextField
                  fullWidth
                  id="customerRepresentative"
                  label={t("customer.customerRepresentative")}
                  name="customerRepresentative"
                  value={customerRepresentative}
                  type="string"
                  inputType="string"
                  onChange={handleChange}
                />
              </Box>

              <Box sx={{ width: "50%", margin: 1 }}>
                <TextField
                  fullWidth
                  id="customerPhone"
                  label={t("customer.customerPhone")}
                  name="customerPhone"
                  value={customerPhone}
                  type="string"
                  inputType="string"
                  onChange={handleChange}
                />
              </Box>
              <Box sx={{ width: "50%", margin: 1 }}>
                <TextField
                  fullWidth
                  id="customerEmail"
                  label={t("customer.customerEmail")}
                  name="customerEmail"
                  value={customerEmail}
                  type="string"
                  inputType="string"
                  onChange={handleChange}
                />
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Paper>
  );
}

export default Customer;
